/**
 * 話者の役割と、画面での表し方 (コード定義 CD-004、インタラクションスタイル §6)。
 *
 * 画面は「話者0 / 話者1」を出さず、役割のラベルだけを出す (#1247 前提 #3。SCR-D-001 DP-D-001)。
 * 色だけに頼らないよう、罫線の種類・アイコン・ラベルを役割ごとに変える (インタラクションスタイル §6)。
 */

/** 役割のコード値 (CD-004 の内部識別子) */
export const SPEAKER_ROLE = {
    agent: 'agent',
    candidate: 'candidate',
    unknown: 'unknown',
};

/**
 * 役割ごとの表示。`icon` は VI 定義 §10 のアイコン名 (lucide)。
 * 不明はインタラクションスタイル §6 が色 (`--color-text-muted`) だけを定め、アイコンを定めていないため持たない。
 */
export const SPEAKER_DISPLAY = {
    [SPEAKER_ROLE.agent]: { label: 'エージェント', icon: 'user-round' },
    [SPEAKER_ROLE.candidate]: { label: '求職者', icon: 'user-round-search' },
    [SPEAKER_ROLE.unknown]: { label: '不明', icon: null },
};

/**
 * 役割のコード値を表示に引き当てる。想定外の値は「不明」として扱う (画面を落とさないため)。
 *
 * @param {string} role
 * @returns {{role: string, label: string, icon: (string|null)}}
 */
export function resolveSpeaker(role) {
    const key = Object.prototype.hasOwnProperty.call(SPEAKER_DISPLAY, role) ? role : SPEAKER_ROLE.unknown;
    return { role: key, ...SPEAKER_DISPLAY[key] };
}
